import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
interface NavbarProps {
  onNavigate: (page: 'landing' | 'projects') => void;
  currentPage: 'landing' | 'projects';
}
export function Navbar({
  onNavigate,
  currentPage
}: NavbarProps) {
  const isLanding = currentPage === 'landing';
  return <nav className={`fixed top-0 left-0 w-full z-50 px-6 py-6 transition-colors duration-300 ${isLanding ? 'mix-blend-difference text-white' : 'bg-white/80 backdrop-blur-md border-b border-neutral-100 text-neutral-900'}`} data-id="element-48">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-49">
        <button onClick={() => onNavigate('landing')} className="font-bold text-xl tracking-tight hover:opacity-70 transition-opacity focus:outline-none" data-id="element-50">
          Stasis.
        </button>

        <div className="flex items-center gap-8" data-id="element-51">
          <div className="hidden md:flex gap-6 text-sm font-medium" data-id="element-52">
            <button onClick={() => onNavigate('projects')} className={`transition-colors ${isLanding ? 'hover:text-neutral-300' : 'hover:text-neutral-600'} ${currentPage === 'projects' ? 'opacity-50 cursor-default' : ''}`} data-id="element-53">
              Projects
            </button>
            <button className={`transition-colors ${isLanding ? 'hover:text-neutral-300' : 'hover:text-neutral-600'}`} data-id="element-54">
              Process
            </button>
            <button className={`transition-colors ${isLanding ? 'hover:text-neutral-300' : 'hover:text-neutral-600'}`} data-id="element-55">
              Contact
            </button>
          </div>

          <button className="md:hidden text-sm font-medium hover:opacity-70 transition-opacity" data-id="element-56">
            Menu
          </button>
        </div>
      </div>
    </nav>;
}